import IndexPage from 'pages/index'
import ConfiguratorPage from 'pages/configurator'
import AuthorizationPage from 'pages/auth'
import EmailConfirmationSuccessPage from 'pages/auth/confirm/success'
import EmailConfirmationErrorPage from 'pages/auth/confirm/error'
import PasswordRecoveryPage from 'pages/auth/recovery'
import ProfilePage from 'pages/profile'
import DashboardPage from 'pages/dashboard'
import KeysPage from 'pages/keys'

import { ViewDashboard, Tune, Key } from 'mdi-material-ui'

export const IndexRoute = {
  path: '/',
  exact: true,
  component: IndexPage
}

export const DashboardRoute = {
  path: '/dashboard',
  exact: true,
  component: DashboardPage,
  hasNavLink: true,
  navLinkTitle: 'Обзор',
  navLinkIcon: ViewDashboard
}

export const ConfiguratorRoute = {
  path: '/configurator',
  exact: true,
  component: ConfiguratorPage,
  hasNavLink: true,
  navLinkTitle: 'Конфигуратор',
  navLinkIcon: Tune
}

export const AuthorizationRoute = {
  path: '/auth',
  exact: true,
  component: AuthorizationPage
}

export const EmailConfirmationSuccessRoute = {
  path: '/auth/confirm/success',
  exact: true,
  component: EmailConfirmationSuccessPage
}

export const EmailConfirmationErrorRoute = {
  path: '/auth/confirm/error',
  exact: true,
  component: EmailConfirmationErrorPage
}

export const PasswordRecoveryRoute = {
  path: '/auth/recovery',
  exact: true,
  component: PasswordRecoveryPage
}

export const ProfileRoute = {
  path: '/profile',
  exact: true,
  component: ProfilePage
}

export const KeysRoute = {
  path: '/keys',
  exact: false,
  component: KeysPage,
  hasNavLink: true,
  navLinkTitle: 'Мои ключи',
  navLinkIcon: Key
}




// WEBPACK FOOTER //
// ./src/routes/config.js